var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CardMedia, Stack, Typography, useTheme } from "@mui/material";
import useIosContext from "@nitra/nkmb-card-components/contexts/IosContextProvider";
import { CardWithShadow, ShareArea } from "../components";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useTranslation } from "react-i18next";
export function LegendWarriorMobileCard(props) {
    var _a;
    var name = props.name, imageUrl = props.imageUrl, to = props.to, cardSubText = props.cardSubText;
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    var isIos = useIosContext().isIos;
    var theme = useTheme();
    return (_jsx(CardWithShadow, __assign({ cardHeightOverride: 141, to: to, sx: {
            display: "flex",
        } }, { children: _jsxs(Stack, __assign({ direction: "row", sx: { width: "100%" } }, { children: [_jsx(CardMedia, { component: "img", sx: {
                        width: 114,
                    }, image: imageUrl, alt: name }), _jsxs(Box, __assign({ sx: { m: 2, position: "relative", flexGrow: 1 } }, { children: [_jsx(Typography, __assign({ variant: "h4", sx: (_a = {},
                                _a[theme.breakpoints.down("sm")] = isIos && {
                                    '@media (-webkit-min-device-pixel-ratio: 2)': {
                                        fontWeight: 500, // Adjust font weight for iPhones
                                    },
                                },
                                _a) }, { children: name })), _jsx(Typography, __assign({ variant: "bodyS", sx: { position: "absolute", bottom: "4px", color: "#676767", pr: 3 } }, { children: cardSubText && getLocalizedString(cardSubText, currentLang) })), _jsx(ShareArea, { shareUrl: to, brightText: false, sx: { position: "absolute", right: 0, bottom: 0, zIndex: 11 } })] }))] })) })));
}
